import {useReduxManualLoaderWithParams} from '../useReduxLoader';
import {Dispatch} from 'redux';
import {veevaLoadDocMetadata, veevaLoadMdpList, veevaLoadMdpModelLanguage, veevaLoadVeap} from './actions';
import {
  veevaDocMetadataSelectorBuilder,
  veevaMdpModelLanguageSelectorBuilder,
  veevaMdpSelectorBuilder,
  veevaVeapSelectorBuilder,
} from './selectors';

const loadMdpModelLanguageIgnoreInvalid = (dispatch: Dispatch, p: string, knownLanguages: string[]) => {
  return p ? veevaLoadMdpModelLanguage(dispatch, p, knownLanguages) : Promise.resolve();
};
loadMdpModelLanguageIgnoreInvalid.clear = veevaLoadMdpModelLanguage.clear;
export const useVeevaMdpModelLanguageLoaderWithParams = () => {
  return useReduxManualLoaderWithParams(veevaMdpModelLanguageSelectorBuilder, loadMdpModelLanguageIgnoreInvalid);
};

const loadVeapIgnoreInvalid = (dispatch: Dispatch, p: string) => {
  return p ? veevaLoadVeap(dispatch, p) : Promise.resolve();
};
loadVeapIgnoreInvalid.clear = veevaLoadVeap.clear;
export const useVeevaVeapLoaderWithParams = () => {
  return useReduxManualLoaderWithParams(veevaVeapSelectorBuilder, loadVeapIgnoreInvalid);
};

const loadMdpIgnoreInvalid = (dispatch: Dispatch, p: string) => {
  return p ? veevaLoadMdpList(dispatch, p) : Promise.resolve();
};
loadMdpIgnoreInvalid.clear = veevaLoadMdpList.clear;
export const useVeevaMdpLoaderWithParams = () => {
  return useReduxManualLoaderWithParams(veevaMdpSelectorBuilder, loadMdpIgnoreInvalid);
};

const loadDocMetadataIgnoreInvalid = (dispatch: Dispatch, veapId: string) => {
  return veapId ? veevaLoadDocMetadata(dispatch, veapId) : Promise.resolve();
};
loadDocMetadataIgnoreInvalid.clear = veevaLoadDocMetadata.clear;
export const useVeevaDocMetadataLoaderWithParams = () => {
  return useReduxManualLoaderWithParams(veevaDocMetadataSelectorBuilder, loadDocMetadataIgnoreInvalid);
};
